import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "increase",
  "use": "increase-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 17\" id=\"increase\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.834 15.682L15.047 5.485l-.248 2.875a1.34 1.34 0 002.195 1.138c.276-.232.45-.56.478-.9l.523-6.091a1.325 1.325 0 00-.059-.52 1.356 1.356 0 00-1.164-.933L10.664.509a1.335 1.335 0 00-1.45 1.214 1.348 1.348 0 001.223 1.451l2.882.258L1.107 13.629c-.994.832-1.482 1.536-.767 2.385.714.85 1.5.5 2.494-.332z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol